import { Layout } from "../components/Layout";

/** Legal page (route "/datenschutz") — kept directly on the landing site so it
 *  stays reachable independent of the app's own gate. */
export function Datenschutz(): JSX.Element {
  return (
    <Layout>
      <div className="container-welope py-14 sm:py-20 lg:py-24">
        <div className="mx-auto max-w-2xl">
          <nav aria-label="Brotkrumen" className="mb-6">
            <ol className="flex items-center gap-2 font-body text-label-sm text-on-surface-variant">
              <li>
                <a href="/" className="transition-colors hover:text-primary">
                  Start
                </a>
              </li>
              <li aria-hidden>›</li>
              <li className="text-primary">Datenschutzerklärung</li>
            </ol>
          </nav>

          <h1 className="font-headline text-[34px] font-extrabold leading-[1.1] tracking-[-0.02em] text-primary sm:text-[46px]">
            Datenschutzerklärung
          </h1>

          <div className="mt-10 space-y-10">
            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                1. Verantwortliche Stelle
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Verantwortlich im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
              </p>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                solutioIT (Inhaber: Jamie Hennemann)
                <br />
                Hauptstraße 5a
                <br />
                56479 Liebenscheid
                <br />
                Telefon: 02667 8323219
                <br />
                E-Mail: info@solutioit.de
              </p>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Für alle Fragen zum Datenschutz und zur Ausübung Ihrer Rechte erreichen Sie uns
                unter der oben genannten E-Mail-Adresse. Ein:e gesonderte:r
                Datenschutzbeauftragte:r ist derzeit nicht bestellt, da hierzu keine gesetzliche
                Verpflichtung besteht.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                2. Grundsätzliches
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Welope ist ein soziales Netzwerk für Haustierbesitzer:innen. Wir betreiben unsere
                gesamte Infrastruktur — Datenbank, Dateispeicher und Anwendungsserver — selbst auf
                eigenen bzw. angemieteten Servern innerhalb der Europäischen Union. Es findet
                keine Übermittlung Ihrer Daten an Server außerhalb der EU/des EWR statt. Aktuell
                setzen wir keine Drittanbieter-Analyse- oder Werbedienste ein; sollte sich das
                ändern (z. B. durch die Einbindung eines Werbenetzwerks zur Finanzierung des
                Betriebs), aktualisieren wir diese Datenschutzerklärung vorab entsprechend.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                3. Welche Daten wir erheben und warum
              </h2>

              <h3 className="mt-5 font-headline text-headline-md text-on-surface">
                3.1 Konto- und Profildaten
              </h3>
              <p className="mt-2 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Bei der Registrierung erheben wir E-Mail-Adresse, ein von Ihnen gewähltes Passwort
                (nur als Hash gespeichert, niemals im Klartext), Anzeigename und Benutzername.
                Optional können Sie ein Profilbild hochladen sowie Profile für Ihre Haustiere
                (Name, Tierart, Rasse, Fotos) anlegen. Diese Daten sind zur Bereitstellung des
                Kontos und der Kernfunktionen von Welope erforderlich (Art. 6 Abs. 1 lit. b DSGVO
                – Vertragserfüllung).
              </p>

              <h3 className="mt-5 font-headline text-headline-md text-on-surface">
                3.2 Standortdaten ("In deiner Nähe")
              </h3>
              <p className="mt-2 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Die Funktion "In deiner Nähe" zeigt Ihnen andere Nutzer:innen in Ihrer Umgebung an.
                Diese Funktion ist standardmäßig deaktiviert. Erst wenn Sie aktiv zustimmen und
                Ihren Standort freigeben, übermittelt Ihr Gerät die geografischen Koordinaten
                (Breiten- und Längengrad) an unseren Server. Wir speichern diese Koordinaten als
                Geo-Punkt in unserer Datenbank (PostGIS), um Entfernungen zu anderen Nutzer:innen
                zu berechnen, sowie den Zeitpunkt Ihrer Einwilligung in einem
                Einwilligungs-Protokoll (Consent-Log). Sie können die Standortfreigabe jederzeit
                in den Einstellungen deaktivieren; in diesem Fall werden die gespeicherten
                Koordinaten umgehend gelöscht und ein Widerruf im Einwilligungs-Protokoll
                vermerkt. Zusätzlich können Sie festlegen, ob Ihr ungefährer Standort für alle
                Nutzer:innen ("Öffentlich") oder nur für Ihre Follower ("Nur Follower") sichtbar
                ist. Rechtsgrundlage ist Ihre ausdrückliche Einwilligung (Art. 6 Abs. 1 lit. a
                DSGVO), die Sie jederzeit mit Wirkung für die Zukunft widerrufen können.
              </p>

              <h3 className="mt-5 font-headline text-headline-md text-on-surface">
                3.3 Fotos, Videos und Beiträge
              </h3>
              <p className="mt-2 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Von Ihnen hochgeladene Fotos und Videos werden auf unserem selbst betriebenen,
                S3-kompatiblen Objektspeicher innerhalb der EU abgelegt und Ihrem Konto
                zugeordnet. Bild- und Videodateien können technisch bedingte Metadaten (z. B.
                Aufnahmedatum, Dateiformat) enthalten; wir werten diese Metadaten nicht gesondert
                aus. Die Verarbeitung erfolgt zur Erbringung der von Ihnen gewünschten
                Vertragsleistung (Art. 6 Abs. 1 lit. b DSGVO).
              </p>

              <h3 className="mt-5 font-headline text-headline-md text-on-surface">
                3.4 Private Nachrichten
              </h3>
              <p className="mt-2 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Inhalte, die Sie über die Direktnachrichten-Funktion an andere Nutzer:innen
                senden, werden verschlüsselt übertragen (TLS) und in unserer Datenbank
                gespeichert, damit Chatverläufe bei erneutem Login verfügbar bleiben. Der Zugriff
                erfolgt ausschließlich über Ihr authentifiziertes Konto (personalisierter
                Echtzeit-Kanal). Rechtsgrundlage ist die Vertragserfüllung (Art. 6 Abs. 1 lit. b
                DSGVO).
              </p>

              <h3 className="mt-5 font-headline text-headline-md text-on-surface">
                3.5 Follows, Benachrichtigungen und Interaktionen
              </h3>
              <p className="mt-2 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wenn Sie anderen Nutzer:innen folgen, Beiträge kommentieren oder liken, speichern
                wir diese Verknüpfungen, um Ihnen Ihren Feed, Follower-/Following-Listen und
                In-App-Benachrichtigungen (z. B. "X folgt dir jetzt") anzuzeigen. Rechtsgrundlage
                ist die Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO) sowie unser berechtigtes
                Interesse an einer funktionierenden Social-Media-Funktionalität (Art. 6 Abs. 1
                lit. f DSGVO).
              </p>

              <h3 className="mt-5 font-headline text-headline-md text-on-surface">
                3.6 Technische Protokolldaten
              </h3>
              <p className="mt-2 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Bei jeder Nutzung der App verarbeiten unsere Server aus technischen Gründen
                temporär IP-Adresse, Zeitpunkt der Anfrage und aufgerufene Funktion, um den
                Betrieb, die Sicherheit und Stabilität der Plattform zu gewährleisten (Art. 6
                Abs. 1 lit. f DSGVO, berechtigtes Interesse an sicherem Betrieb).
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                3.7 Warteliste (Marketing-Seite)
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Solange Welope noch nicht öffentlich verfügbar ist, können Sie sich auf unserer
                Marketing-Seite mit Ihrer E-Mail-Adresse für die Warteliste eintragen. Wir
                speichern diese Adresse ausschließlich, um Sie zu benachrichtigen, sobald die
                Anmeldung möglich ist, und geben sie nicht an Dritte weiter. Rechtsgrundlage ist
                Ihre Einwilligung durch aktives Absenden des Formulars (Art. 6 Abs. 1 lit. a
                DSGVO). Nach dem Start von Welope bzw. auf Ihren Wunsch löschen wir den Eintrag.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                4. Cookies und lokale Speicherung
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Aktuell setzen wir keine Tracking- oder Marketing-Cookies und keine Analyse- oder
                Werbedienste Dritter ein; sollte sich das künftig ändern, informieren wir vorab an
                dieser Stelle und holen, soweit rechtlich erforderlich, Ihre Einwilligung ein. Die
                Web-Version von Welope speichert Ihr Anmelde-Token (Access- und Refresh-Token)
                ausschließlich im lokalen Speicher (localStorage) Ihres Browsers, damit Sie nach
                einem Neuladen der Seite angemeldet bleiben. Diese Speicherung ist rein funktional
                notwendig und erfolgt nicht zu Analyse- oder Werbezwecken (Art. 6 Abs. 1 lit. b
                DSGVO). Die mobile App speichert das Anmelde-Token entsprechend lokal auf Ihrem
                Gerät. Während der Entwicklungsphase setzen wir zusätzlich einen technisch
                notwendigen Cookie, der den Zugriff auf die noch nicht öffentlich freigegebene
                Seite auf berechtigte Personen beschränkt; dieser Cookie entfällt mit dem
                Live-Gang. Schriftarten werden ausschließlich von unserem eigenen Server
                ausgeliefert, nicht von Drittanbietern wie Google Fonts – beim Laden unserer Seite
                werden also keine Daten an Google zur Bereitstellung von Schriftarten übertragen.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                4a. Anmeldung über Apple
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wenn Sie sich freiwillig für "Weiter mit Apple" statt der klassischen Anmeldung
                per E-Mail und Passwort entscheiden, stellt Ihr Browser bzw. Ihr Gerät eine
                Verbindung zu den Servern von Apple Distribution International her, um Ihre
                Identität zu bestätigen. Dabei kann Apple Daten wie Ihre IP-Adresse verarbeiten;
                wir erhalten von Apple lediglich Ihre E-Mail-Adresse und Ihren Namen zur
                Erstellung bzw. Zuordnung Ihres Welope-Kontos. Diese Datenübertragung findet nur
                statt, wenn Sie diese Anmeldeoption aktiv auswählen, und beruht auf Ihrer
                Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Näheres entnehmen Sie den{" "}
                <a
                  href="https://www.apple.com/legal/privacy/de-ww/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-bold text-secondary hover:opacity-80"
                >
                  Datenschutzhinweisen von Apple
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                4b. Reichweitenmessung auf der Landingpage (Plausible Analytics)
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Nur auf dieser Marketing-Landingpage (nicht in der App) setzen wir das
                Open-Source-Analysetool Plausible Analytics ein, das wir selbst auf unserem
                eigenen Server unter analytics.solutioit.de betreiben. Plausible verzichtet
                bewusst auf Cookies und jede Form von Cross-Site-Tracking: Es wird keine
                eindeutige Kennung (z. B. Fingerprinting) gespeichert, mit der Sie über mehrere
                Besuche oder Websites hinweg wiedererkannt werden könnten. Erfasst werden lediglich
                aggregierte, anonyme Kennzahlen wie aufgerufene Seiten, Referrer, Land, Browser und
                Gerätetyp; Ihre IP-Adresse wird ausschließlich zur Ermittlung des ungefähren
                Standorts (Land) kurz verarbeitet und anschließend nicht gespeichert. Da keine
                personenbezogenen Daten über die Zeit gespeichert oder mit anderen Diensten
                zusammengeführt werden, ist keine gesonderte Einwilligung nach § 25 TTDSG
                erforderlich; Rechtsgrundlage ist unser berechtigtes Interesse an einer
                datenschutzfreundlichen Reichweitenmessung (Art. 6 Abs. 1 lit. f DSGVO). Mehr zur
                Funktionsweise finden Sie unter{" "}
                <a
                  href="https://plausible.io/data-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-bold text-secondary hover:opacity-80"
                >
                  plausible.io/data-policy
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                5. Speicherdauer
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke
                erforderlich ist bzw. solange Ihr Konto besteht. Löschen Sie Ihr Konto über die
                Einstellungen, werden Ihre Profildaten, Haustierprofile, hochgeladenen Medien,
                Beiträge, Standortdaten und Nachrichten gelöscht bzw. unwiderruflich anonymisiert.
                Ausgenommen hiervon sind Daten, zu deren Aufbewahrung wir gesetzlich verpflichtet
                sind (z. B. handels- oder steuerrechtliche Aufbewahrungsfristen) sowie
                Einwilligungs-Protokolle, die wir zum Nachweis erteilter und widerrufener
                Einwilligungen für einen angemessenen Zeitraum aufbewahren.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                6. Weitergabe an Dritte
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Eine Übermittlung Ihrer Daten an Dritte findet grundsätzlich nicht statt. Da wir
                unsere Infrastruktur selbst hosten (Server, Datenbank und Objektspeicher für
                Medien betreiben wir bzw. ein von uns beauftragter EU-Hosting-Anbieter im Rahmen
                eines Auftragsverarbeitungsvertrags gemäß Art. 28 DSGVO), verbleiben Ihre Daten
                innerhalb unserer eigenen Systeme. Eine Weitergabe an weitere Dritte erfolgt nur,
                wenn wir gesetzlich dazu verpflichtet sind (z. B. gegenüber
                Strafverfolgungsbehörden) oder Sie zuvor ausdrücklich eingewilligt haben.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                7. Ihre Rechte
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Ihnen stehen als betroffene Person nach der DSGVO folgende Rechte zu:
              </p>
              <ul className="mt-4 space-y-2">
                {[
                  "Recht auf Auskunft über die zu Ihrer Person gespeicherten Daten (Art. 15 DSGVO)",
                  "Recht auf Berichtigung unrichtiger Daten (Art. 16 DSGVO) – viele Angaben können Sie direkt in den Einstellungen selbst korrigieren",
                  'Recht auf Löschung ("Recht auf Vergessenwerden", Art. 17 DSGVO) – jederzeit selbstständig über "Konto löschen" in den Einstellungen möglich',
                  "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
                  "Recht auf Datenübertragbarkeit (Art. 20 DSGVO) – Sie erhalten Ihre Daten auf Anfrage in einem gängigen, maschinenlesbaren Format",
                  "Widerspruchsrecht gegen Verarbeitungen, die auf berechtigtem Interesse beruhen (Art. 21 DSGVO)",
                  "Recht auf jederzeitigen Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO), z. B. für die Standortfreigabe",
                  "Recht auf Beschwerde bei einer Datenschutzaufsichtsbehörde (Art. 77 DSGVO)",
                ].map((item) => (
                  <li
                    key={item}
                    className="flex gap-3 font-body text-body-md leading-[1.55] text-on-surface-variant"
                  >
                    <span
                      aria-hidden
                      className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary"
                    />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Zur Ausübung dieser Rechte genügt eine formlose E-Mail an info@solutioit.de.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                8. Datensicherheit
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten gegen
                Manipulation, Verlust und unberechtigten Zugriff zu schützen, darunter
                verschlüsselte Übertragung (TLS), gehashte Passwörter sowie
                Zugriffsbeschränkungen auf unsere Infrastruktur. Trotz aller Sorgfalt kann eine
                vollständige Sicherheit vor allen Risiken nicht garantiert werden.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                9. Änderungen dieser Datenschutzerklärung
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wir passen diese Datenschutzerklärung an, wenn sich unsere Datenverarbeitung
                ändert. Die jeweils aktuelle Fassung finden Sie stets auf dieser Seite.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
